declare var window:any;
export class PlayerBase{
    public async Delay(time:number)
    {
        return new Promise<number>(function(resolve){
            setTimeout(()=>{
                resolve();
            },time);

        });
    }

    public FireEvent(selector:string,eventName:string,args:any)
    {
        this.ExecuteJQueryEvent(jQuery,selector,eventName,args);
        if(typeof window.rnJQuery!='undefined')
            this.ExecuteJQueryEvent(window.rnJQuery,selector,eventName,args);

    }

    private ExecuteJQueryEvent(jQuery: JQueryStatic, selector: string, eventName: string, args: any) {
        let event=jQuery.Event('click');
        for(var property in args)
            event[property]=args[property];

        jQuery(selector).trigger(event);
    }
}



// WEBPACK FOOTER //
// ./Player/PlayerElements/PlayerBase.ts